/**
 * Guide sections published at avantti.com.ar/productores/guias/<id>. The key is
 * the section's path segment; the value is how the landing site names it.
 *
 * Only sections listed here get a `?` in <AdminSectionTitle>. The guides site
 * also lists "Próximamente" topics (venta presencial, pixel) — they
 * have no page yet, so they are deliberately absent.
 */
export const HELP_GUIDE_SECTIONS = {
  'crear-evento': 'Crear tu evento',
  entradas: 'Entradas',
  asistentes: 'Asistentes',
  cupones: 'Cupones',
  liquidaciones: 'Liquidaciones',
  vendedores: 'Vendedores',
  reportes: 'Reportes',
  equipo: 'Equipo y accesos',
  escaneo: 'Escaneo',
  referidos: 'Referidos',
  productora: 'Tu productora',
} as const;

export type HelpGuideSection = keyof typeof HELP_GUIDE_SECTIONS;
